module.exports = __webpack_public_path__ + "media/images/spa et centre de bien-être-70815b35dc2918974b46b33143231faf.svg";